import { useCallback, useContext } from 'react'
import { LocationContext } from '@BUP/contexts/LocationContext'
import { resolveGradeName } from '@BUP/services/BraveUp'

/**
 * Returns a function that turns a course-assignment grade (a `nivel:N` tag, e.g. 'nivel:4') into
 * the name the school knows it by (e.g. '4° Básico'), using the school's own country - same as
 * MySchoolPage/Students and the sociogram work groups. The period still stores and sends the raw
 * tag; this is display-only. Outside a LocationContext (or for an unknown grade) it returns the
 * raw tag unchanged.
 * @returns {(grade: string) => string}
 */
export const useGradeName = () => {
  const location = useContext(LocationContext)
  const locale = location?.locale
  return useCallback(grade => resolveGradeName(locale, grade), [locale])
}
